export default __webpack_public_path__ + "static/media/banner-alt.bc5fbe88.png";